import { render, staticRenderFns } from "./StockCostList.vue?vue&type=template&id=b0070b18&scoped=true&"
import script from "./StockCostList.vue?vue&type=script&lang=ts&"
export * from "./StockCostList.vue?vue&type=script&lang=ts&"
import style0 from "./StockCostList.vue?vue&type=style&index=0&id=b0070b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0070b18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VSimpleTable})
